import { envSchema, type Env } from "./env-schema";

export * from "./env-schema";

// Only validate on server side (typeof window === "undefined")
// On client side, only NEXT_PUBLIC_* vars are available anyway
function getEnv(): Env {
	if (typeof window === "undefined") {
		return envSchema.parse(process.env);
	}

	// On client, just return process.env without validation
	// Only NEXT_PUBLIC_* vars are available anyway
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return process.env as unknown as Env;
}

export const env = getEnv();
